import React, { useCallback } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Empty, Popconfirm, Space, Tag, Tooltip } from 'antd'
import {
  CloseOutlined,
  TeamOutlined,
} from '@ant-design/icons'
import { yellowPrimary } from '../../color'
import { AvatarHasName } from '../Common/Avatar'
import SelectGroupMemberBox from './SelectGroupMemberBox'
import {
  ASSIGNEE_TYPE,
} from '../../constants'

const SelectGroupMemberPopup = props => {
  const {
    isVisibleSelectGroupPopup,
    handleSubmitSelectGroup,
    handleCancelSelectGroup,
    selectPeopleStore,
  } = props

  const { selectGroupData, setSelectGroupData } = selectPeopleStore

  const onCancelSelectGroup = () => {
    handleCancelSelectGroup()
  }

  const handleRemoveSelect = useCallback(
    group => {
      setSelectGroupData({
        ...selectGroupData,
        [ASSIGNEE_TYPE.HANDLER]: selectGroupData[ASSIGNEE_TYPE.HANDLER].filter(
          el => el.id !== group.id
        ),
      })
    },
    [selectGroupData]
  )

  return (
    <Modal
      className="custom-modal-wrapper assign-member-modal"
      maskClosable={false}
      okText={'Đồng ý'}
      cancelText={'Hủy bỏ'}
      width={800}
      footer={null}
      style={{ top: 20 }}
      title={
        <div className="assign-member-modal-title-container">
          <div>
            <span style={{ fontSize: 16, fontWeight: 500 }}>Bảng chọn nhóm</span>
          </div>
          <div className="group-btn-action">
            <Popconfirm
              placement="bottom"
              title={'Bạn có chắc chắn muốn xóa hết người được chọn không ?'}
              onConfirm={onCancelSelectGroup}
              okText="Đồng ý"
              cancelText="Không"
              zIndex={1600}>
              <Button danger style={{ borderRadius: 8 }}>
                Hủy chọn
              </Button>
            </Popconfirm>
            <Button type={'primary'} style={{ borderRadius: 8 }} onClick={handleSubmitSelectGroup}>
              Đồng ý
            </Button>
            <Tooltip title={'Đóng'}>
              <CloseOutlined style={{ fontSize: 20, cursor: 'pointer' }} onClick={handleSubmitSelectGroup} />
            </Tooltip>
          </div>
        </div>
      }
      closable={false}
      forceRender={true}
      visible={isVisibleSelectGroupPopup}>
      <div className="assign-member-modal-left-box">
        <div className="assign-member-modal-left-content" style={{ position: 'relative' }}>
          <SelectGroupMemberBox />
        </div>
      </div>
      <div className="assign-member-modal-right-box">
        <div
          style={{
            marginBottom: 16,
            fontWeight: 500,
            color: '#333',
          }}>
          Danh sách đã chọn:
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8,
          }}>
          {selectGroupData[ASSIGNEE_TYPE.HANDLER].length > 0 &&
            selectGroupData[ASSIGNEE_TYPE.HANDLER].map((el, index) => {
                  return (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={index}
                      closable
                      onClose={() => handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={<TeamOutlined />}
                      />
                    </Tag>
                  )
                })}
        </div>
      </div>
    </Modal>
  )
}

SelectGroupMemberPopup.propTypes = {}

export default inject('selectPeopleStore', 'userStore')(observer(SelectGroupMemberPopup))
